import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type CheckListProps = IconComponentBaseProps;

export const CheckList = ({
  className,
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.gray[7],
}: CheckListProps) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <mask
        id="mask0_9110_35794"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_9110_35794)">
        <path
          d="M5.66931 16.3385L9.39231 12.6155C9.54114 12.4667 9.71681 12.3933 9.91931 12.3953C10.1218 12.3971 10.2975 12.4756 10.4463 12.6308C10.5846 12.7818 10.6538 12.958 10.6538 13.1595C10.6538 13.3608 10.5846 13.5358 10.4463 13.6845L6.32706 17.8193C6.14623 17.9999 5.93531 18.0903 5.69431 18.0903C5.45331 18.0903 5.24239 17.9999 5.06156 17.8193L3.01731 15.775C2.87898 15.6365 2.81139 15.4624 2.81456 15.2528C2.81773 15.0433 2.88856 14.8693 3.02706 14.7308C3.16556 14.5923 3.34014 14.523 3.55081 14.523C3.76148 14.523 3.93498 14.5923 4.07131 14.7308L5.66931 16.3385ZM5.66931 8.72301L9.39231 5.00001C9.54114 4.85134 9.71681 4.77792 9.91931 4.77976C10.1218 4.78176 10.2975 4.86034 10.4463 5.01551C10.5846 5.16651 10.6538 5.34267 10.6538 5.54401C10.6538 5.74551 10.5846 5.92059 10.4463 6.06926L6.32706 10.2038C6.14623 10.3846 5.93531 10.475 5.69431 10.475C5.45331 10.475 5.24239 10.3846 5.06156 10.2038L3.01731 8.15951C2.87898 8.02117 2.81139 7.84717 2.81456 7.63751C2.81773 7.42784 2.88856 7.25384 3.02706 7.11551C3.16556 6.97701 3.34014 6.90776 3.55081 6.90776C3.76148 6.90776 3.93498 6.97701 4.07131 7.11551L5.66931 8.72301ZM13.7596 16.5578C13.5471 16.5578 13.369 16.4858 13.2253 16.342C13.0815 16.1982 13.0096 16.0199 13.0096 15.8073C13.0096 15.5948 13.0815 15.4167 13.2253 15.273C13.369 15.1295 13.5471 15.0578 13.7596 15.0578H20.7596C20.9721 15.0578 21.1502 15.1297 21.2941 15.2735C21.4377 15.4173 21.5096 15.5955 21.5096 15.808C21.5096 16.0207 21.4377 16.1988 21.2941 16.3423C21.1502 16.4859 20.9721 16.5578 20.7596 16.5578H13.7596ZM13.7596 8.94226C13.5471 8.94226 13.369 8.87034 13.2253 8.72651C13.0815 8.58267 13.0096 8.40451 13.0096 8.19201C13.0096 7.97934 13.0815 7.80126 13.2253 7.65776C13.369 7.51409 13.5471 7.44226 13.7596 7.44226H20.7596C20.9721 7.44226 21.1502 7.51417 21.2941 7.65801C21.4377 7.80184 21.5096 7.98009 21.5096 8.19276C21.5096 8.40526 21.4377 8.58334 21.2941 8.72701C21.1502 8.87051 20.9721 8.94226 20.7596 8.94226H13.7596Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
